import Noty from 'noty'
import moment from 'moment'
declare global {
  interface Window {
    runConfig: any
  }
}
//
export const BASE_URL = window.runConfig.BaseURL
export const UserDataKey = window.runConfig.Keys.UserData
//

export const IsLoggedIn = () => {
  return ReadLocalStorage(UserDataKey) != undefined
}

export const IsAdmin = () => {
  return ReadLocalStorage(UserDataKey).roleName === 'ADMIN'
}

export const ValueFromUserData = (key: string) => {
  let UserData: any = ReadLocalStorage(UserDataKey)

  if (UserData != undefined && UserData != null) {
    // console.log(UserData, key)
    return UserData[key]
  } else {
    return ''
  }
}

export const ReduceString = (text: string) => {
  return text
    .trim()
    .replace(/ /g, '')
    .toLowerCase()
}

export const SetLocalStorage = (key: string, value: string) => {
  localStorage.setItem(key, value)
}

export const ReadLocalStorage = (key: string) => {
  let result = localStorage.getItem(key)
  if (result == undefined || result == null) {
    return undefined
  } else {
    return JSON.parse(result)
  }
}

export const RemoveFromLocalStorage = (key: string) => [
  localStorage.removeItem(key)
]

export const getUrlSearchParam = (query: string, key: string) => {
  const urlSearch = new URLSearchParams(query)
  return urlSearch.get(key);
}

// NOTIFICATION //
type NotificationType =
  | 'alert'
  | 'success'
  | 'warning'
  | 'info'
  | 'error'
  | 'information'
  | undefined

export const NotificationHandler = (
  notyType: NotificationType,
  message: string
) => {
  console.log('in notification')
  const notification = new Noty({
    type: notyType,
    // layout: "topCenter",
    text: `<h2 className="noti-message">${message}</h2>`,
    timeout: 2000,
    theme: 'sunset'
  })
  notification.show()
}
//-//

export const StandardDateFormat = (Date: any) => {
  return moment(Date).format('MMM DD, YYYY')
}

export const FormatCurrency = (value: string | number) => {
  if (value == undefined || value == null) return `$0`
  return `$${value}`
}

export const FilterRecords = async (
  Records: any[] = [],
  Keys: string[] = [],
  SearchString: string = ''
): Promise<any[]> => {
  let FilteredArray: any = []
  return new Promise<any[]>(resolve => {
    Records.forEach((val: any, idx: number) => {
      for (let iterator = 0; iterator < Keys.length; iterator++) {
        if (
          val[Keys[iterator]] != null &&
          val[Keys[iterator]] != undefined &&
          ReduceString(val[Keys[iterator]].toString()).includes(
            ReduceString(SearchString)
          )
        ) {
          FilteredArray.push(val)
          break
        }
      }
      //   return obj.VAL.indexOf(value) !== -1;

      if (Records.length == idx + 1) {
        resolve(FilteredArray)
      }
    })
  })
}

export const SummarizeText = (text: string, count: number) => {
  if (text == undefined || text == null) {
    return ''
  }

  if (text.length <= count) {
    return text
  }

  return text.substr(0, count) + '...'
}

export const fullDateFormat = (date: string) => {
  return moment(date).format('MMMM DD YYYY, h:mm a')
}

export const monthNames = ["January","February","March","April","May","June","July",
"August","September","October","November","December"];